import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { rootFixedColor } from 'styles/theme';

// 기존에 연결되어 있는 button
export const DefaultBtn = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  background-color: ${rootFixedColor.primaryColor};
  color: ${rootFixedColor.rootTextColor};
  &:hover {
    opacity: 0.7;
  }
`;
// 새로 만든 공통 버튼
const CommonButton = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;

  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
  
  &:disabled {
    cursor: default;
    background-color: ${({theme}) => theme.newTheme.button.disabledBtnBg};
    color: ${({theme}) => theme.newTheme.button.disabledBtnText};
    
    &:hover {
      cursor: default;
      opacity: 1;
    }
  }
`;
// primary_blue color 버튼
export const PrimaryButton = styled(CommonButton)`
  background-color: ${({theme}) => theme.newTheme.button.primaryBtnBg};
  color: #fff;
`;
// primary_pink color 버튼
export const PrimaryPinkButton = styled(CommonButton)`
  background-color: ${({theme}) => theme.newTheme.button.primaryPinkBtnBg};
  color: #fff;
`;
// 테두리 primary_blue color 버튼
export const OutlinePrimaryButton = styled(CommonButton)`
  border: 1px solid ${({theme}) => theme.newTheme.button.primaryBtnBg};
  color: ${({theme}) => theme.newTheme.button.primaryBtnBg};
  &:hover {
    background-color: ${({ theme }) => theme.newTheme.button.primaryBtnBg};
    color: #fff;
  }
`;
// 테두리 primary_pink color 버튼
export const OutlinePrimaryPinkButton = styled(CommonButton)`
  border: 1px solid ${({theme}) => theme.newTheme.button.primaryPinkBtnBg};
  color: ${({theme}) => theme.newTheme.button.primaryPinkBtnBg};
  &:hover {
    background-color: ${({ theme }) => theme.newTheme.button.primaryPinkBtnBg};
    color: #fff;
  }
  &:disabled {
    border: 1px solid ${({theme}) => theme.newTheme.button.disabledBtnBg};
    background-color: ${({theme}) => theme.newTheme.button.disabledBtnBg};
    color: ${({theme}) => theme.newTheme.button.disabledBtnText};
  }
`;
// 흰색 color 버튼
export const WhiteButton = styled(CommonButton)`
  background-color: ${({theme}) => theme.newTheme.button.whiteBtnBg};
`;
export function DefaultButton({ text }: { text: string }) {
  return (
    <DefaultBtn type="button">{ text }</DefaultBtn>
  );
}
export function LinkToButton({ text, linkStr }: { text: string, linkStr: string }) {
  const navigate = useNavigate();
  return (
    <DefaultBtn type="button" onClick={() => navigate(`${linkStr}`)}>{ text }</DefaultBtn>
  );
}
